import axios from 'axios';
import { API_URL } from '../constants/index.js';
import { useInterceptor } from './apiUtils';

useInterceptor(axios);

export function lookupGroupDeparture({ journey_slug, year_month }) {
	return axios({
		method: 'get',
		url: `${API_URL}/group_departures/lookup`,
		params: { journey_slug, year_month },
	});
}

export function reserveGroupDeparture(data) {
	return axios({
		method: 'post',
		url: `${API_URL}/group_departures/reserve`,
		data: { group_departure: data },
	});
}
